<template>
  <div>
    <h1>Session Expire! Please login again</h1>
    <div>
      <input type="button" value="Login Again" v-on:click="redirectLogin"/>
    </div>
  </div>
</template>
<style scoped>
  div{
    background-color: aliceblue;
    color: black;
    text-align: center;
    width:100% ;
  }
</style>
<script>
import vue from "vue";
import Router from "vue-router";
export default {
  name: "SessionExpire",
  components: {},
  data() {
    return {};
  },
  methods: {
    redirectLogin(){
      this.$root.$data.sessionPage=1;
      this.$router.push({ name: "Login" });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SessionExpire.vue